document.addEventListener('DOMContentLoaded', function() {  

    // if(document.querySelector('.menu-btn')){
    //     const menuBtn = document.querySelector('.menu-btn');
    //     const menu = document.querySelector('.menu-container');
    //     const body = document.body;

    //     menuBtn.addEventListener('click', () => {
    //         menu.classList.toggle('active');
    //         menuBtn.classList.toggle('active');
    //         body.classList.toggle('no-scroll');
    //     });       
    // }
    function initializeSplide(selector, options, extensions) {
        const splideInstances = [];

        document.querySelectorAll(selector).forEach(element => {
            if (element.querySelector('.splide__track') && element.querySelector('.splide__list')) {
                const instanceOptions = { ...options };

                if (element.classList.contains('destroy-slider')) {
                    instanceOptions.destroy = true;
                }

                const splide = new Splide(element, instanceOptions).mount(extensions);
                splideInstances.push(splide);
            }
        });

        return splideInstances;
    }


    if (document.querySelector('.collection-slider')) {
        initializeSplide('.collection-slider .splide', {
            type: 'loop',
            perPage: 1,
            pagination: true,
            arrows: false,
            gap: 24,
            autoplay: true,
            interval: 3000,
        });
    }
    document.querySelectorAll('.oint-js-atb a[href]').forEach(a => {
        // Get href and normalize (ignore trailing slashes)
        const linkUrl = new URL(a.href, window.location.origin);
        const currentUrl = new URL(window.location.href);

        if (linkUrl.origin + linkUrl.pathname !== currentUrl.origin + currentUrl.pathname) {
            a.setAttribute('target', '_blank');
        }
    });


    function moveChildrenExceptFirst(sourceSelector, targetSelector) {
        console.log('ini');
        const source = document.querySelector(sourceSelector);
        const target = document.querySelector(targetSelector);
        console.log(source,target);

        if (!source || !target) {
            console.warn("Invalid selectors provided.");
            return;
        }

        // Get all children except the first one
        const childrenToMove = Array.from(source.children).slice(1);
        console.log(childrenToMove);

        // Append each child to target
        childrenToMove.forEach(child => {
            target.appendChild(child);
        });
        console.log(target);
    }

    if(document.querySelector('product-info .product__description') && document.querySelector('product-info .custom-id-description .accordion__content')){
        moveChildrenExceptFirst('product-info .product__description','product-info .custom-id-description .accordion__content');
    }
    if(document.querySelector('.collection-description .rich-text__text') && document.querySelector('.collection-description-extra .rich-text__text')){
        moveChildrenExceptFirst('.collection-description .rich-text__text','.collection-description-extra .rich-text__text');
    }
});